<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.order_no"
        placeholder="订单号"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.user_id"
        placeholder="用户ID"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.phone"
        placeholder="手机号"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-date-picker
        class="filter-item"
        v-model="dateArr"
        type="datetimerange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd HH:mm:ss"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      <el-select
        v-model="listQuery.pay_status"
        placeholder="支付状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="待支付" :value="1" />
        <el-option label="支付成功" :value="2" />
        <el-option label="订单取消" :value="4" />
      </el-select>
      <el-select
        v-model="listQuery.pay_type"
        placeholder="支付方式"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <!-- <el-option label="余额支付" :value="1" /> -->
        <el-option label="支付宝" :value="2" />
        <el-option label="微信APP" :value="3" />
        <!-- <el-option label="微信小程序" :value="4" /> -->
        <el-option label="首信易" :value="5" />
        <el-option label="微信H5" :value="6" />
        <el-option label="墨者支付" :value="9" />
        <el-option label="小马支付" :value="10" />
         <el-option label="汇元支付" :value="11" />
          <el-option label="杉德支付" :value="12" />
      </el-select>
      <el-input
        v-model="listQuery.product_name"
        placeholder="商品名称"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <span class="filter-item">
        <download-excel
          :fields="json_fields"
          :fetch="handleExport"
          :before-generate="startPost"
          :before-finish="endPost"
          type="xls"
          name="订单信息.xls"
          worksheet="订单信息"
          :header="header"
        >
          <el-button type="warning" :loading="exportLoading">
            导出订单信息
          </el-button>
        </download-excel>
      </span>
    </div>
    <div class="filter-container">
      <!-- <el-radio-group v-model="listQuery.status" size="small" @change="handleFilter">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="1">未匹配</el-radio-button>
        <el-radio-button label="2">待买家打款</el-radio-button>
        <el-radio-button label="3">已完成</el-radio-button>
        <el-radio-button label="4">已取消</el-radio-button>
      </el-radio-group> -->
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column label="订单号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <img
            :src="scope.row.user ? scope.row.user.avatar : '#'"
            class="user-avatar"
          />
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.account }}
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.nickname : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="商品名称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ JSON.parse(scope.row.product_snap).name }}
        </template>
      </el-table-column>
      <el-table-column label="商品图片" min-width="80" align="center">
        <template slot-scope="scope">
          <img
            :src="JSON.parse(scope.row.product_snap).cover"
            class="user-avatar"
          />
        </template>
      </el-table-column>
      <el-table-column label="金额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_money }}
        </template>
      </el-table-column>
      <el-table-column label="支付时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_at }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="支付方式"
        min-width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.pay_type === 1" type="warning"
            >余额支付</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 2" type="success"
            >支付宝</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 3" type="success"
            >微信APP</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 4" type="success"
            >微信小程序</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 5" type="success"
            >首信易</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 6" type="success"
            >微信H5</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 9" type="success"
            >墨者支付</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 10" type="success"
            >小马支付</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 11" type="success"
            >汇元支付</el-tag
          >
          <el-tag v-else-if="scope.row.pay_type === 12" type="success"
            >杉德支付</el-tag
          >
          <el-tag v-else type="danger">未支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="支付状态"
        min-width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.pay_status === 1" type="warning"
            >待支付</el-tag
          >
          <el-tag v-else-if="scope.row.pay_status === 2" type="success"
            >支付成功</el-tag
          >
          <el-tag v-else-if="scope.row.pay_status === 3" type="success"
            >支付失败</el-tag
          >
          <el-tag v-else-if="scope.row.pay_status === 4" type="danger"
            >订单取消</el-tag
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import downloadExcel from "vue-json-excel";
export default {
  components: { downloadExcel },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        type: "",
        status: "",
        order_no: "",
        buyer_id: "",
        seller_id: "",
      },
      dialogFormVisible: false,
      btnLoading: false,
      exportLoading: false,
      form: {},
      dateArr: null,
      //导出
      json_fields: {
        订单号: {
          field: "order_no",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        用户ID: "user_id",
        手机号: {
          field: "user.account",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        昵称: "user.nickname",
        商品名称: {
          field: "product_snap",
          //自定义回调函数
          callback: (value) => {
            return JSON.parse(value).name;
          },
        },
        金额: {
          field: "pay_money",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        支付时间: {
          field: "pay_at",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        创建时间: {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        支付方式: {
          field: "pay_type",
          //自定义回调函数
          callback: (value) => {
            if (value == 2) {
              return "支付宝";
            } else if (value == 3) {
              return "微信APP";
            } else if (value == 5) {
              return "首信易";
            } else if (value == 6) {
              return "微信H5";
            } else if (value == 9) {
              return "墨者支付";
            }  else if (value == 10) {
              return "小马支付";
            }else if (value == 11) {
              return "汇元支付";
            }else if (value == 12) {
              return "杉德支付";
            }else {
              return "无";
            }
          },
        },
        支付状态: {
          field: "pay_status",
          //自定义回调函数
          callback: (value) => {
            if (value == 1) {
              return "待支付";
            } else if (value == 2) {
              return "支付成功";
            } else if (value == 3) {
              return "支付失败";
            } else if (value == 4) {
              return "订单取消";
            }
          },
        },
      },
    };
  },
  created() {
    this.getList();
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {
    handleExport() {
      this.exportLoading = true;
      var query = JSON.parse(JSON.stringify(this.listQuery));
      query.limit = 99999999999999;
      return request({
        url: "/api/backend/product/orders",
        method: "get",
        params: query,
      })
        .then((result) => {
          var json_data = result.data.data;
          this.header = "订单信息";
          return json_data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.listLoading = false;
          this.exportLoading = false;
        });
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/product/orders",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleEdit(object) {
      this.form = JSON.parse(JSON.stringify(object));
      this.dialogFormVisible = true;
    },
    saveData() {
      this.btnLoading = true;
      request({
        url: "/api/backend/task/save",
        method: "post",
        data: this.form,
      })
        .then((response) => {
          this.btnLoading = false;
          this.dialogFormVisible = false;
          this.$notify({
            title: "成功",
            message: "保存成功",
            type: "success",
            duration: 2000,
          });
          this.getList();
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
